<template>
  <div>
    <HeaderRoutinePrint :routineExecution="routineExecution" />
    <DetailRoutinePrint
      :routineExecution="routineExecution"
      :checklistItems="checklistItems"
    />
    <div class="d-flex justify-center align-center">
      <p
        class="pa-0 my-4 body-2 font-weight-bold blue-grey--text text--darken-3"
      >
        {{ $t('assignments.finding_other') }}
      </p>
    </div>

    <ListFinding
      v-for="finding in findingsChunk"
      :key="finding.id"
      :finding="finding"
      :findingNumber="findingNumber"
      :routineId="routineExecution.id"
    />
  </div>
</template>

<script>
import HeaderRoutinePrint from './HeaderRoutinePrint.vue'
import DetailRoutinePrint from './DetailRoutinePrint.vue'
import ListFinding from './ListFinding.vue'
export default {
  name: 'MainPageRoutinePrint',
  components: {
    HeaderRoutinePrint,
    DetailRoutinePrint,
    ListFinding,
  },
  props: {
    routineExecution: {
      type: Object,
      required: true,
    },
    findingsChunk: {
      type: Array,
      required: false,
    },
    checklistItems: {
      type: Array,
    },
    findingNumber: Number,
    totalPages: Number,
  },
  computed: {
    hasPages() {
      return Boolean(this.totalPages > 0)
    },
  },
}
</script>
<style lang="scss" scoped>
.pages {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  font-size: 10px;
}
</style>
